export enum OnboardingSteps {
    ViewPdf = 0,
    EmployeeProfile = 1,
    AvionteOnboarding = 2,
}
